/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Resource } from 'i18next';
import { ThemeProvider } from 'styled-components';
import { theme } from '@marriott/mi-ui-library-shop';
import type { ComponentProps } from './index.types';
import { useConditionalPageContextSERP } from '../../hooks/useConditionalPageContextSERP';
import { getSearchQueryDataFromSession } from './lib/helper';
import { getSessionIDFromCookie } from '../../utils/helper';
import { MErrorHandlerAlert } from '../../molecules/MErrorHandlerAlert';
import OSearchResults from './searchResultsMainComponent';

interface OSearchResultsProps {
  miSearchResults: Resource;
  searchResults?: Partial<ComponentProps>;
  model?: Record<string, any>;
  isAuthorMode: boolean;
  AiSearchResults?: any;
  onOpenHotelPanel?: (propertyData: any, propertyId: string, options?: { messageViewData?: any }) => void;
  onPropertyMediaLoaded?: (propertiesMedia: any[]) => void;
  isStaticMap?: boolean;
  isMapLoading?: boolean;
  messageUiData?: any;
  aiFilterUpdateData?: any;
  aiPreSelectedFacets?: any;
  searchQueryData?: any;
  isMapView?: boolean;
  chatIsFlexDate?: boolean;
  /** True when response contains a single property (e.g., availability_calendar_search) */
  isSinglePropertyResponse?: boolean;
  GOOGLE_MAP_API_KEY?: string;
}

export const OSearchResultsComponent: React.FC<OSearchResultsProps> = pageProps => {
  const { currentLocale, sessionData: pageSessionData, isAuthorMode } = useConditionalPageContextSERP();

  const [initialState] = useState<any>();
  const searchResultProps = pageProps?.model || pageProps;
  const [jsonContent, setJsonContent] = useState<any>(searchResultProps);
  const [updatedTheme, setUpdatedTheme] = useState<any>({ ...theme, dir: '' });

  const sessionData = pageSessionData?.data ? pageSessionData?.data : pageSessionData?.cacheData?.data;

  let sessionToken = '';
  if (sessionData) {
    const sessionObj = sessionData?.data ? sessionData : sessionData?.cacheData;
    sessionToken = sessionObj?.data?.sessionToken || sessionObj?.key || getSessionIDFromCookie() || '';
  }
  const newSearchQueryData =
    pageProps.searchQueryData || getSearchQueryDataFromSession(sessionData, sessionToken, currentLocale || 'en-US');

  useEffect(() => {
    const searchResultProps = pageProps?.model || pageProps;
    setJsonContent(searchResultProps);
    setUpdatedTheme({
      ...theme,
      dir: '',
    });
  }, [pageProps]);

  const ampRequest =
    pageProps?.AiSearchResults?.rawData?.data?.search?.conversationalSearch?.searchByNaturalLanguageQuery?.ampRequest;

  const renderComponent = () => {
    return (
      <MErrorHandlerAlert alertMessage={jsonContent?.['componentErrorMessage']}>
        <ThemeProvider theme={updatedTheme}>
          <OSearchResults
            {...initialState}
            jsonContent={jsonContent}
            searchQueryData={newSearchQueryData}
            completeSession={pageSessionData?.data ? pageSessionData : pageSessionData?.cacheData}
            isAuthorMode={isAuthorMode}
            AiSearchResults={pageProps.AiSearchResults}
            onOpenHotelPanel={pageProps.onOpenHotelPanel}
            onPropertyMediaLoaded={pageProps.onPropertyMediaLoaded}
            isStaticMap={pageProps.isStaticMap}
            isMapLoading={pageProps.isMapLoading}
            messageUiData={pageProps.messageUiData}
            aiFilterUpdateData={pageProps.aiFilterUpdateData}
            aiPreSelectedFacets={pageProps.aiPreSelectedFacets}
            ampRequest={ampRequest}
            chatIsMapView={pageProps.isMapView}
            chatIsFlexDate={pageProps.chatIsFlexDate}
            isSinglePropertyResponse={pageProps.isSinglePropertyResponse}
            GOOGLE_MAP_API_KEY={pageProps.GOOGLE_MAP_API_KEY ?? ''}
          />
        </ThemeProvider>
      </MErrorHandlerAlert>
    );
  };

  return renderComponent();
};
